export default __webpack_public_path__ + "static/Agrandir-Light-053d4f6d97b03d64160119b6d6dd3e25.woff2";